import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Fade } from "react-awesome-reveal";

function HeroSection() {
  return (
    <div className="hero-section text-center">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <Fade triggerOnce direction="down" duration={800}>
              {/* <p className="text-light-blue mb-2 title">About Us</p> */}
              <h1>Empowering Smarter Investments</h1>
            </Fade>
            <Fade triggerOnce delay={300} duration={800}>
              <p className="mt-3 mb-4">
                Right Spade, a SEBI-registered Research Analyst (INH000018799), is built for investors who seek precision over speculation and depth over hype. We provide transparent, well-researched insights to help navigate the markets with confidence.
              </p>
              <p>
              Join us as we redefine how investors approach wealth creation through our research and recommendations.
              </p>
            </Fade>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default HeroSection;